import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CandidateClientService {

  constructor(private http: HttpClient) { }
  configUrl = environment.settings.apiEndpoint + '/api/CandidateSource/';

  saveEntry(value:string) {
    return this.http.post<string>(this.configUrl+"SaveEntry",value);
  }

}
